export interface MatchConfig {
  chalkSim?: boolean;
  preset: 'bar' | 'tournament' | 'custom';
  scratch: 'kitchen' | 'anywhere';
  calls: 'none' | 'eight' | 'all';
  eightOnBreak: 'win' | 'spot';
  scratchOnEightLoss: boolean;
  assignOnBreak: boolean;
  strictBreak: boolean;
  breakPlacement?: boolean;
  normalMax: number;
  breakMax: number;
}
export const BAR_RULES: MatchConfig = { chalkSim:false, preset: 'bar', scratch: 'kitchen', calls: 'eight', eightOnBreak: 'win', scratchOnEightLoss: false, assignOnBreak: true, strictBreak: false, breakPlacement: true, normalMax: 3.5, breakMax: 9.5 };
export const TOURNAMENT_RULES: MatchConfig = { ...BAR_RULES, preset: 'tournament', scratch: 'anywhere', calls: 'all', eightOnBreak: 'spot', scratchOnEightLoss: false, assignOnBreak: false, strictBreak: true };
export function matchConfig(input: Partial<MatchConfig> = {}): MatchConfig {
  if (input.preset === 'tournament') return { ...TOURNAMENT_RULES, chalkSim:input.chalkSim===true };
  if (input.preset !== 'custom') return { ...BAR_RULES, chalkSim:input.chalkSim===true };
  return {
    ...BAR_RULES, preset: 'custom', chalkSim:input.chalkSim===true,
    scratch: input.scratch === 'anywhere' ? 'anywhere' : 'kitchen',
    calls: input.calls === 'none' || input.calls === 'all' ? input.calls : 'eight',
    eightOnBreak: input.eightOnBreak === 'spot' ? 'spot' : 'win',
    scratchOnEightLoss: input.scratchOnEightLoss ?? BAR_RULES.scratchOnEightLoss,
    assignOnBreak: input.assignOnBreak ?? true,
    strictBreak: input.strictBreak ?? BAR_RULES.strictBreak,
    breakPlacement: input.breakPlacement ?? true,
    normalMax: Number.isFinite(input.normalMax) ? Math.max(1, Math.min(8.5, input.normalMax!)) : 3.5,
    breakMax: Number.isFinite(input.breakMax) ? Math.max(1, Math.min(12, input.breakMax!)) : 9.5,
  };
}
export const rulesName = (c: MatchConfig) => c.preset === 'bar' ? '8-Ball (Bar)' : c.preset === 'tournament' ? '8-Ball (Tourny)' : '8-Ball (Custom)';
